module.exports = __webpack_public_path__ + "img/4034449.b307a7ed.webp";